import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormlyFieldConfig } from 'ng-formly';
import { GridOptions } from 'ag-grid/main';
import { evalExpression } from 'ng-formly/src/core/utils';
import { LoopBackFilter, Entityrecord } from '../../../sdk/models';
import { AccountApi, EntityApi, EntityfieldApi, EntityrecordApi } from '../../../sdk/services/custom';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import * as _ from 'lodash';
import { EntityService } from '../../../services/entity.service';
import { ValidationService } from '../../../services/validation.service';
import { GridUtilities } from '../../../components/grid/GridUtilities';
import { CacheService, CacheStoragesEnum } from 'ng2-cache/ng2-cache';
import { PlatformApp } from '../../../services/app.service';
import { WindowRef } from '../../../services/window.service';
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';
import 'rxjs/add/operator/takeUntil';
import { Subject } from 'rxjs/Subject';
import { GridButtonsComponent } from './grid-buttons.component';
import zipcelx from 'zipcelx';
import { Http, Headers } from '@angular/http';
import { BASE_URL, API_VERSION, NEWBASE_URL } from '../../../../../environments/environment';
import { encrypt, isNotBlank, isNotEmpty } from '../../../utils/util';

@Component({
    selector: 'grid-list-widget',
    templateUrl: './grid-list.component.html',
    providers: [EntityApi, EntityfieldApi, EntityrecordApi, EntityService, NotificationsService, PushNotificationsService],
    styleUrls: ['./grid-list.component.scss']
})

export class GridListWidgetComponent implements OnInit, OnDestroy {

    @Input() entitytype: string;
    @Input() inputentityid: string;
    @Input() searchlayoutid: string;
    @Input() parentId;

    @Input() gridheight: string;
    @Input() inversegridheight: number;

    @Input() hidetopbuttons: string = 'false';
    @Input() hideaddbutton: string = 'false';
    @Input() paginationpagesize: string = '15';
    @Input() showaddfilter = 'true';
    @Input() showinnerform: string = 'false';
    @Input() usecache: string;

    // Simple Single Field Filter
    @Input() filtername: string;
    @Input() filtervalue: string;
    @Input() filteroptions: Object;

    // Values - 'today', 'yesterday', 'thisweek' ,'nextweek' , 'last7days' , 'lastweek' ,'thismonth' ,'nextmonth' ,'lastmonth' 
    @Input() datefilter: string;
    @Input() datefield: string;

    // Values - Active, InActive        Field - data.status
    @Input() status: string;

    // To Mute the notifications for Refresh and Load
    @Input() silent: string = 'false';

    gridwidth = '100%';
    calcgridheight = '500px';
    showGrid = false;
    showError = false;
    public gridOptions: GridOptions;
    subscriptions: any = [];
    entityid: any;
    entity: any;
    entityRecord: any = {};
    appid: any = '';
    entityname = '';
    rowData: any;
    columnDefs: any = [];
    entityDataFields: any;
    records: any;
    currentuser: any;
    formfields: any = [];
    entityrecordid: any = '';
    entityrecordname: any = '';
    topbuttonsOn = true;
    addbuttonOn = true;
    addfilterOn = true;
    refreshtime;
    notifyOptions = PlatformApp.getNotificationOptions();
    ngUnsubscribe: Subject<any> = new Subject<any>();
    loadText = 'Loading';
    appData = {};

    // Form Related
    initialFormData: any;
    formErrors = [];
    get formValid() { return this.form['invalid']; }
    get peekMode() { return this.form['viewMode'] || false; }
    get showInnerForm() { return this.showinnerform == 'true' || false; }
    get notifyLoad() { return this.silent !== 'true' }
    get paginationPageSize() {
        if (this.paginationpagesize && Number(this.paginationpagesize) > 0) {
            return Number(this.paginationpagesize);
        }
        else {
            return 15;
        }
    }
    options: any = {};
    quickFilter = '';

    //filter options
    lookupmap: any;
    /****Formly ***/
    form: FormGroup;
    // form: FormGroup;
    author;
    env;

    public events: any[] = [];
    entityFormFields: Array<FormlyFieldConfig> = [];
    entityFormFieldsString: string = '';
    gridSortModel;
    gridFilterModel;
    filterRecord = {};
    model = {};
    filterRecords: any = [];
    filterRecordsString: string = '';
    recordFilter: LoopBackFilter = <LoopBackFilter>{ where: {} };
    // public status = { isopen: false };
    skip = 0;
    limit = 0;
    searchfields = [];
    searchfieldnames = [];
    searchfieldlabels = [];
    sortfields = [];
    recordcount = 1;
    currentsearchlayout: any = {};
    entitysearchlayouts = [];
    entitydatacolumns = [];
    defaultSortField = '';
    defaultSortType = '';
    firstLoad = true;

    /****************Modals************************* */
    @ViewChild('newModal') public newModal: ModalDirective;
    @ViewChild('peekModal') public peekModal: ModalDirective;
    @ViewChild('loadingModal') public loadingModal: ModalDirective;
    @ViewChild('confirmModal') public confirmModal: ModalDirective;
    @ViewChild('reasonModal') public reasonModal: ModalDirective;

    alertform: FormGroup;
    alertrecord: any;
    bk_cancel_reason_fields = [{
        // this field's ng-model will be bound to vm.model.username
        key: 'reason',
        type: 'select',
        defaultValue: "Unavailable",
        templateOptions: {
            "label": "Select your cancellation reason",
            required: true,
            options: [
                {
                    "value": "Unavailable",
                    "label": "Unavailable"
                },
                {
                    "label": "Wrong Location",
                    "value": "Wrong Location"
                },
                {
                    "label": "Test Order",
                    "value": "TestOrder"
                },
                {
                    "label": "Customer Requested",
                    "value": "Customer Requested"
                },
                {
                    "label": "Not Delivered",
                    "value": "Not Delivered"
                },
                {
                    "label": "Wrong Items",
                    "value": "Wrong Items"
                },
                {
                    "label": "Other Reasons",
                    "value": "Other Reasons"
                }
            ]
        }
    }];
    alertformfields: any = _.cloneDeep(this.bk_cancel_reason_fields);
    order: any;

    bk_activate_action_fields = [
        {
            key: 'field',
            type: 'select',
            defaultValue: 'active',
            templateOptions: {
                "label": "Select the field to update",
                required: true,
                options: [
                    {
                        "value": 'active',
                        "label": "Activate/Deactivate"
                    },
                    {
                        "value": 'open',
                        "label": "Open/Close"
                    }
                ]
            }
        },
        {
            key: 'active',
            type: 'select',
            templateOptions: {
                "label": "Select the action",
                required: true,
                options: [
                    {
                        "value": true,
                        "label": "Activate"
                    },
                    {
                        "value": false,
                        "label": "Deactivate"
                    }
                ]
            },
            hideExpression: "model.field != 'active'"
        }, {
            key: 'open',
            type: 'select',
            templateOptions: {
                "label": "Select the action",
                required: true,
                options: [
                    {
                        "value": true,
                        "label": "Open"
                    },
                    {
                        "value": false,
                        "label": "Close"
                    }
                ]
            },
            hideExpression: "model.field != 'open'"
        }];
    active_field_exists = false;
    open_field_exists = false;

    adminEmailIds = ['ashish@gokhana.com', 'ankur@gokhana.com', 'hitesh@gokhana.com', 'sarfraz@ampcome.com', 'arun@ampcome.com', 'arun01Amp@gokhana.com'];
    constructor(private route: ActivatedRoute, private fb: FormBuilder, private router: Router, private winRef: WindowRef,
        private _EntityApi: EntityApi, private _EntityfieldApi: EntityfieldApi, private _http: Http,
        private _Account: AccountApi, private _EntityrecordApi: EntityrecordApi,
        private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService,
        private _LoopBackAuth: LoopBackAuth, private _EntityService: EntityService, private _CacheService: CacheService,
        private _PlatformApp: PlatformApp) {
    }

    ngOnInit(): void {
        this.onResize();
        this.topbuttonsOn = this.hidetopbuttons == 'false';
        this.addbuttonOn = this.hideaddbutton == 'false'
        this.addfilterOn = this.showaddfilter == 'true'
        this._CacheService.useStorage(CacheStoragesEnum.MEMORY);

        this.form = this.fb.group({});

        this.form['subscriptions'] = [];
        this.form['formValidity'] = true;
        this.form['viewMode'] = false;
        this.showError = false;

        this.alertform = this.fb.group({});
        this.alertform['subscriptions'] = [];
        this.alertform['formValidity'] = true;
        this.alertform['viewMode'] = false;

        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        this.appid = this.currentuser.appId;
        this.route.queryParams
            .mergeMap(queryparams => this.route.params.map(params => { return { 'queryparams': queryparams, 'params': params } }))
            .subscribe((result: any) => {
                this.entitytype = result.params['entitytype']; // (+) converts string 'id' to a number
                this.recordFilter = result.queryparams['recordfilter'];
                if (this.recordFilter && typeof this.recordFilter === 'string') { this.recordFilter = JSON.parse(this.recordFilter); }
                this.getEntityDetails();
            });
    }

    getHeaders(): Headers {
        let h = new Headers();
        h.append('content-type', 'application/json');
        h.append('authorization', this._LoopBackAuth.getAccessTokenId())
        h.append('x-clientapp', 'platformui')
        h.append('appversion', '0.0.19');
        return h;
    }

    getEntityDetails(): void {
        this.firstLoad = true;
        let entityFilter: LoopBackFilter = <LoopBackFilter>{ where: {} };
        entityFilter.where['appId'] = this.appid;
        if (this.inputentityid) { entityFilter.where['id'] = this.inputentityid; }
        if (this.entitytype) { entityFilter.where['name'] = this.entitytype; }
        this._EntityApi.getDetailsforEntity(entityFilter)
            .subscribe((response: any) => {
                if (response && response.status && response.status === 'ok') {
                    let details = _.cloneDeep(response);
                    this.refreshtime = new Date();

                    this.entity = details.entity;
                    if (this.entity.showinnerform) {
                        this.showinnerform = 'true';
                    }
                    this.entityid = details.entity.id;
                    if (this.entityid == '5be411650f3f594b7fcb796b') {
                        this.addbuttonOn = this.hideaddbutton == 'false' && this.adminEmailIds.indexOf(this.currentuser.email) >= 0;
                    }
                    this.entityFormFields = details.formfields;
                    this.entityDataFields = details.datafields;
                    this.appData = details.appData;
                    this.entityFormFieldsString = JSON.stringify(details.formFields);
                    this.entitysearchlayouts = details.searchlayouts;
                    this.entitydatacolumns = details.datacolumns;
                    this.columnDefs = this.setCurrentSearchLayout(this.searchlayoutid);
                    if (this.showInnerForm) {
                        this.hideModals();
                        this.entityRecord = {};
                        if (this.parentId) {
                            this.entityRecord['parentId'] = this.parentId;
                        }
                        this.entityrecordid = null;
                        this.formfields = _.cloneDeep(this.entityFormFields);
                        this.populateformfields();
                        this.form['appData'] = this.appData;
                        this.form['viewMode'] = false;
                    }
                    this.showError = false;
                    this.showGrid = true;

                    if (!this.silent) {
                        this.notify('success', 'Refreshed', this.entity.plural_label);
                    }
                    if (this.gridOptions && this.gridOptions.api) {
                        this.getRecords();
                    } else {
                        this.refreshGridDetails();
                    }
                } else {
                    this.showError = true;
                    this.showGrid = false;
                    console.log('Error in getDetailsforEntity - Entity Not Loaded: ' + JSON.stringify(entityFilter));
                    this.notify('error', 'Entity', 'Not Loaded');
                }
            }, (err: any) => {
                this.showGrid = false;
                this.showError = true;
                if (err.error instanceof Error) {
                    console.log('Error in getDetailsforEntity :', err.error.message);
                } else {
                    console.log(`Error in getDetailsforEntity : code ${err.status}, body was: ${err.error}`);
                }
            });
    }

    refreshGridDetails() {
        this.gridOptions = <GridOptions>{
            enableServerSideSorting: true,
            enableColResize: true,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: 'infinite',
            infiniteInitialRowCount: 1,
            enableFilter: false,
            enableSorting: true,
            pagination: true,
            paginationPageSize: Number(this.paginationPageSize),
            paginationStartPage: Number(this.paginationPageSize),
            cacheBlockSize: Number(this.paginationPageSize),
            getRowNodeId: function (item) { return item.id; },
            context: { componentParent: this },
            onGridReady: () => {
                this.getRecords();
            },
            onSelectionChanged: (event) => {
                if (event.type == "selectionChanged") {
                    let selected_records = this.gridOptions.api.getSelectedRows();
                    console.log('selected_records count', selected_records.length);
                    if (isNotEmpty(selected_records) && selected_records.length > 1) {
                        this.active_field_exists = selected_records.some(t => t && t.data && t.data.hasOwnProperty("active"))
                        this.open_field_exists = selected_records.some(t => t && t.data && t.data.hasOwnProperty("open"))
                    } else { this.active_field_exists = false; this.open_field_exists = false; }
                }
            }
        };
    }

    getRecords() {
        this.gridOptions.api.showLoadingOverlay();
        if (this.showInnerForm) {
            this.resetForm();
            this.entityRecord = {};
            if (this.parentId) {
                this.entityRecord['parentId'] = this.parentId;
            }
            this.entityrecordid = null;
            this.formfields = _.cloneDeep(this.entityFormFields);
            this.populateformfields();
            this.form['appData'] = this.appData;
            this.form['viewMode'] = false;
        }

        let recordFilter = this.setupRecordFilter();
        if (this.recordFilter) {
            for (let field in this.recordFilter) {
                if (field && this.recordFilter[field]) {
                    recordFilter.where[field] = this.recordFilter[field];
                }
            }
        }
        let cp;
        if (this.entity.collection && this.entity.collection != 'entityrecord') {
            if (this.entity.collection == 'foodorder' || this.entity.collection == 'payment') {
                cp = Promise.resolve({ count: 10000000 })
            } else {
                cp = this._http.get(BASE_URL + '/' + API_VERSION + '/' + this.getApiNameFromCollection(this.entity.collection) + '/count', {
                    headers: this.getHeaders(),
                    params: { where: recordFilter.where }
                }).toPromise().then(v => v.json()).catch(error => {
                    console.log('Error while updating password', error);
                });
            }
        } else {
            cp = this._EntityrecordApi.count(recordFilter.where).toPromise();
        }
        cp.then(value => {
            // console.log(value);
            this.recordcount = value.count;
            if (this.recordcount == 0) this.gridOptions.api.showNoRowsOverlay();
            if (!this.silent) {
                this.notify('info', 'Loaded ', value.count + ' ' + this.entity.plural_label);
            }
            this.getPageData(recordFilter);
            this.showGrid = true;
            this.showError = false;

        })
    }

    getPageData(recordFilter) {
        let pageData = {
            rowCount: this.recordcount, // use null to behave as infinite scroll
            getRows: (params: any) => {
                let sortField;
                let sortType;
                if (!this.firstLoad && params.sortModel && params.sortModel[0] && params.sortModel[0].colId && params.sortModel[0].sort) {
                    sortField = params.sortModel[0].colId;
                    sortType = params.sortModel[0].sort;
                } else if (this.defaultSortField && this.defaultSortType) {
                    sortField = this.defaultSortField;
                    sortType = this.defaultSortType;
                }

                for (let i = 0; i < this.columnDefs.length; i++) {
                    let column = this.columnDefs[i];
                    if (column && column.sort) {
                        column.sort = null;
                    }
                    if (sortField && sortType && column && column.field && sortField === column.field) {
                        column.sort = sortType;
                    } else if (sortField && sortType && column && column.field && sortField === column.id) {
                        column.sort = sortType;
                        sortField = column.field;
                    }
                }

                if (sortField && sortType) {
                    recordFilter['order'] = sortField + ' ' + sortType;
                }
                recordFilter['skip'] = params.startRow;
                recordFilter['limit'] = params.endRow - params.startRow;
                this.firstLoad = false;
                this.gridOptions.api.showLoadingOverlay();
                this._EntityApi.getEntityRecords(this.entityid, recordFilter)
                    .subscribe((rowData: any) => {
                        this.gridOptions.api.hideOverlay();
                        this.showGrid = true;
                        this.showError = false;

                        let lastRow = -1;
                        if (params.startRow + rowData.length < params.endRow) { lastRow = params.startRow + rowData.length; }
                        params.successCallback(rowData, this.recordcount);

                        this.onResize();
                        if (this.gridOptions && this.gridOptions.api) {
                            if (rowData.length === 0) {
                                this.gridOptions.api.showNoRowsOverlay();
                            } else {
                                this.gridOptions.api.hideOverlay();
                            }
                            this.gridOptions.api.setColumnDefs(this.columnDefs);
                            this.gridOptions.api.sizeColumnsToFit();
                        }
                    }, (err: any) => {
                        this.gridOptions.api.hideOverlay();
                        this.recordcount = 0;
                        if (err.error instanceof Error) {
                            console.log('Error in getEntityRecords :', err.error.message);
                        } else {
                            console.log(`Error in getEntityRecords : code ${err.status}, body was: ${err.error}`);
                        }
                    });
            }
        };
        this.gridOptions.api.setDatasource(pageData);
    }

    setupRecordFilter() {
        let recordFilter: LoopBackFilter = <LoopBackFilter>{ where: {} };
        recordFilter.where['appId'] = this.appid;
        recordFilter.where['entityId'] = this.entityid;

        if (this.parentId) {
            recordFilter.where['data.parentId'] = this.parentId;
        }

        if (this.filtername && this.filtervalue) {
            recordFilter.where['data.' + this.filtername] = this.filtervalue;
        }

        // Add data filters
        if (Array.isArray(this.filterRecords) && this.filterRecords.length > 0) {
            for (let index = 0; index < this.filterRecords.length; index++) {
                let filter = this.filterRecords[index];
                if (!filter['filterfield']) { continue; }

                let key = 'data.' + filter['filterfield'];
                let condition = PlatformApp.getCondition(filter['filtercondition']);
                let value = filter['filtervalue'];

                if (filter['filterValueType'] === 'boolean') {
                    value = Boolean(Number(filter['filtervalue']));
                } else if (filter['filterValueType'] === 'number') {
                    if (condition === 'between') {
                        try {
                            value = JSON.parse(filter['filtervalue']);
                        } catch (error) {
                            console.log(error);
                        }
                    } else {
                        value = Number(filter['filtervalue']);
                    }
                } else if (filter['filterValueType'] === 'date') {
                    value = PlatformApp.getDateVariableValues(filter['filtervalue'], condition);
                    condition = '';
                } else if (filter['filterValueType'] === 'text') {
                    if (condition == "like" || condition == "ilike") { value = '.*' + filter['filtervalue'] + '.*'; }
                    if (condition == '' || condition == 'neq' || condition == 'eq') { value = filter['filtervalue'].toString(); }
                } else {
                    value = filter['filtervalue'].toString();
                }

                recordFilter.where[key] = {};
                if (condition) {
                    recordFilter.where[key][condition] = value;
                    if (condition == "like" || condition == "nlike") {
                        recordFilter.where[key]["options"] = "i";
                    } else if (condition == "empty") {
                        recordFilter.where["or"] = recordFilter.where["or"] || [];
                        recordFilter.where["or"].push({ key: { exists: false } });
                        recordFilter.where["or"].push({ key: { eq: "" } });
                    } else if (condition == "not-empty") {
                        recordFilter.where["or"] = recordFilter.where["or"] || [];
                        recordFilter.where["or"].push({ key: { exists: true } });
                        recordFilter.where["or"].push({ key: { nlike: "[a-zA-Z0-9!@#$&%()-`,.+\/\"]", options: "i" } });
                    }
                } else {
                    recordFilter.where[key] = value;
                }
            }
        }

        if (this.status) {
            recordFilter.where['data.status'] = this.status;
        }

        if (this.datefilter && this.datefield) {
            recordFilter.where[this.datefield] = PlatformApp.getDateFilter(this.datefilter);
        }

        return recordFilter;
    }

    setCurrentSearchLayout(searchlayoutid) {
        let datacolumns = _.cloneDeep(this.entitydatacolumns);
        let searchlayouts = _.cloneDeep(this.entitysearchlayouts);
        let searchlayout: any;

        this.searchfields = [];
        this.searchfieldnames = [];
        this.searchfieldlabels = [];
        this.defaultSortField = '';
        this.defaultSortType = '';

        if (Array.isArray(searchlayouts) && searchlayouts.length > 0) {
            searchlayout = _.find(searchlayouts, { id: searchlayoutid })
            if (!searchlayout) {
                searchlayout = searchlayouts[0];
            }

            if (Array.isArray(searchlayout.fields) && searchlayout.fields.length > 0) {
                this.searchfields = searchlayout.fields;
            }
            if (Array.isArray(searchlayout.fieldnames) && searchlayout.fieldnames.length > 0) {
                this.searchfieldnames = searchlayout.fieldnames;
            }
            if (Array.isArray(searchlayout.fieldlabels) && searchlayout.fieldlabels.length > 0) {
                this.searchfieldlabels = searchlayout.fieldlabels;
            }
            if (Array.isArray(searchlayout.defaultsort) && searchlayout.defaultsort.length > 0) {
                this.defaultSortField = searchlayout.defaultsort[0];
            }
            if (searchlayout.defaultsorttype) {
                this.defaultSortType = searchlayout.defaultsorttype;
            }
            this.currentsearchlayout = searchlayout;
        }

        if (Array.isArray(datacolumns) && datacolumns.length > 0) {
            for (let i = 0; i < datacolumns.length; i++) {
                if (datacolumns[i].headerName) {
                    if (Array.isArray(this.searchfields) && this.searchfields.length > 0) {
                        let index = this.searchfields.indexOf(datacolumns[i].id);
                        if (index > -1) {
                            datacolumns[i].hide = false;
                        } else {
                            datacolumns[i].hide = true;
                        }
                    }
                }

                //Add the proper Comparator for Currency fields
                if (datacolumns[i].fieldtype === 'currency') {
                    datacolumns[i].comparator = GridUtilities.numberComparator;
                }

                if (this.checkforDateColumn(datacolumns[i])) {
                    datacolumns[i].comparator = GridUtilities.dateComparator;
                    datacolumns[i].cellRenderer = GridUtilities.dateRenderer;
                }

                //Finally delete the datacolumn if it is a repeatedsection or subentity
                if (datacolumns[i].fieldtype === 'repeatedsection' || datacolumns[i].fieldtype === 'subentity') {
                    delete datacolumns[i];
                }
            }
        }

        //Add the buttons component
        let buttonscolumn = {
            headerName: '',
            cellRendererFramework: GridButtonsComponent,
            colId: 'params',
            suppressSizeToFit: true,
            width: 120,
            maxwidth: 200,
            minwidth: 100
        }

        datacolumns.push(buttonscolumn);
        return datacolumns;
    }

    onFilterChanged(records) {
        this.filterRecords = records;
        this.filterRecordsString = JSON.stringify(this.filterRecords);
        this.getRecords();
    }

    ngOnChanges(change) {
        if (change && change.entitytype && !change.entitytype.firstChange
            && (change.entitytype.previousValue !== change.entitytype.currentValue)) {
            this.quickFilter = '';
            this.filterRecords = [];
            this.filterRecordsString = JSON.stringify(this.filterRecords);
        }
    }

    public onQuickFilterChanged($event) {
        this.quickFilter = $event.target.value;
        if (this.quickFilter.length > 2) {
            this.getRecords();
        }
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
        for (let i = 0; i < this.form['subscriptions'].length; i++) { this.form['subscriptions'][i].unsubscribe(); }
    }

    confirmDelete(entityrecord) {
        this.entityRecord = entityrecord;
        if (!this.entityrecordid || (entityrecord.id && this.entityrecordid !== entityrecord.id)) {
            this.entityrecordid = entityrecord.id;
        }
        this.confirmModal.show();
    }


    processCustomAction(entityrecord) {
        this.entityRecord = entityrecord;
        if (!this.entityrecordid || (entityrecord.id && this.entityrecordid !== entityrecord.id)) {
            this.entityrecordid = entityrecord.id;
        }
        let cp;
        if (this.entity.collection && this.entity.collection != 'entityrecord') {
            cp = this._http.get(`${BASE_URL}/${API_VERSION}/${this.getApiNameFromCollection(this.entity.collection)}/customaction/${this.entityrecordid}`, {
                headers: this.getHeaders()
            }).toPromise().then(v => v.json()).catch(error => {
                console.log('Error while executing custome action', error);
            });
        } else {
            cp = this._EntityrecordApi.customAction(this.entityrecordid).toPromise();
        }
        cp.then((result) => {
            this.notify('success', 'Processed ' + this.entity.label, this.entityrecordid);
        }).catch(err => { console.error(err) });
    }

    deleteRecord(entityrecord?): void {
        let password = prompt("Enter in the password");
        if (password == "Venturing500") {
            this._deleteRecord(entityrecord);
        } else {
            alert("That's an invalid password.")
        }
    }

    _deleteRecord(entityrecord?): void {
        this.confirmModal.hide();
        if (!this.entityrecordid || (this.entityRecord.id && this.entityRecord.id !== this.entityrecordid)) {
            this.entityrecordid = this.entityRecord.id;
        }
        let eid = this.entityrecordid;
        if (!eid && entityrecord) { eid = entityrecord.id; }

        let name = eid;
        if (this.entity.record_name && this.entityRecord.data && this.entityRecord.data[this.entity.record_name]) {
            name = this.entityRecord.data[this.entity.record_name];
        } else if (this.entityRecord.data && this.entityRecord.data['name']) {
            name = this.entityRecord.data['name'];
        }
        let cp;
        if (this.entity.collection && this.entity.collection != 'entityrecord') {
            cp = this._http.delete(`${BASE_URL}/${API_VERSION}/${this.getApiNameFromCollection(this.entity.collection)}/${eid}`, { headers: this.getHeaders() })
                .toPromise().then(v => v.json()).catch(error => {
                    console.log('Error while deleting', error);
                });
        } else {
            cp = this._EntityrecordApi.deleteById(eid).toPromise();
        }

        cp.then((result) => {
            if (result && result['count'] && result['count'] === 1) {
                this.notify('success', 'Deleted ' + this.entity.label, name);
                this.getRecords();
            } else {
                this.notify('error', 'Delete ' + this.entity.label, JSON.stringify(result));
            }
        }).catch(err => {
            console.error(err);
        });
    }

    checkFieldIsEmpty(fieldname): boolean {
        return this.formfields.find(formField => formField.key == fieldname).formControl.value ? true : false;
    }

    submitRecord(entityRecord): void {
        this.formErrors = [];
        this.form['formValidity'] = true;
        this.model = entityRecord;

        this.validateFields(this.formfields);
        this.setFormErrors(this.formErrors);
        this.form['subscriptions'].push(this._EntityfieldApi.validateRecord(this.entityid, entityRecord)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((result) => {
                if (entityRecord.has_login && !this.checkFieldIsEmpty('password')) {
                    this.form['formValidity'] = false;
                    result.response.push({ field: "password", error: "required" });
                }
                if (result && Array.isArray(result.response) && result.response.length > 0) {
                    this.form['formValidity'] = false;
                    this.setFormErrors(result.response);
                }
                if (this.form['formValidity']) {
                    this.patchOrCreateEntity(entityRecord);
                }
            }, (err: any) => {
                // Handle 400 status code errors
                if (err && err.status === 400) {
                    let errorMessage = 'Validation failed';
                    if (err.error && err.error.message) {
                        errorMessage = err.error.message;
                    } else if (err.error && typeof err.error === 'string') {
                        errorMessage = err.error;
                    } else if (err.message) {
                        errorMessage = err.message;
                    }
                    this.notify('error', 'Validation Error', errorMessage);
                } else {
                    // Handle other errors
                    let errorMessage = 'An error occurred while submitting the form';
                    if (err && err.message) {
                        errorMessage = err.message;
                    } else if (err && err.error && err.error.message) {
                        errorMessage = err.error.message;
                    }
                    this.notify('error', 'Error', errorMessage);
                }
                console.error('Error in submitRecord:', err);
            }));
    }

    validateFields(formfields) {
        for (let index = 0; index < formfields.length; index++) {
            let field = formfields[index];
            if (field.fieldGroup && field.fieldGroup.length > 0) {
                this.validateFields(field.fieldGroup);
            } else {
                if (field.expressionProperties && field.expressionProperties['templateOptions.required']) {
                    if (evalExpression(field.expressionProperties['templateOptions.required'].expression, this, [this.model])) {
                        if (!this.model[field.key]) {
                            this.formErrors.push({ 'field': field.key, 'error': 'required' });
                        }
                    }
                }
            }
        }
    }

    setFormErrors(formErrors) {
        for (let i = 0; i < formErrors.length; i++) {
            let errorField = formErrors[i].field;
            let errorKey = formErrors[i].error;
            let error = {};
            error[errorKey] = true;
            this.form['formValidity'] = false;
            if (this.form.controls[errorField]) {
                this.form.controls[errorField].markAsTouched();
                this.form.controls[errorField].setErrors(error);
            }
        }
    }

    patchOrCreateEntity(entityRecord): void {
        this.loadingModal.hide();
        this.loadText = 'Saving';
        this.loadingModal.show();
        this.hideModals();
        let entityrecordid = this.entityrecordid;
        // Save or Create Entity Record
        let entityRecordforSave = new Entityrecord();
        entityRecordforSave.data = this.entityRecord;
        entityRecordforSave.lastupdatedby = this.currentuser.id;
        entityRecordforSave.appId = this.appid;

        //Hack to remove the appId;
        delete entityRecordforSave.data.appId;

        //Hack to update Date and Time in UI TimeZone.
        for (let i = 0; i < this.entityDataFields.length; i++) {
            if (this.entityDataFields[i].fieldtype === 'date' || this.entityDataFields[i].fieldtype === 'datetime') {
                let dateStr = PlatformApp.stringToDate(entityRecordforSave.data[this.entityDataFields[i].name], null, null);
                if (dateStr) {
                    entityRecordforSave.data[this.entityDataFields[i].name] = dateStr;
                }
            }
        }

        if (!entityrecordid) {
            entityRecordforSave.entityId = this.entity.id;
            entityRecordforSave.createdby = this.currentuser.id;

            let cp;
            if (this.entity.collection && this.entity.collection != 'entityrecord') {
                cp = this._http.patch(`${BASE_URL}/${API_VERSION}/${this.getApiNameFromCollection(this.entity.collection)}`, entityRecordforSave, {
                    headers: this.getHeaders()
                }).toPromise().then(v => v.json()).catch(error => {
                    console.log('Error while creating', error);
                    throw error; // Re-throw to be caught by the outer catch
                });
            } else {
                cp = this._EntityrecordApi.patchOrCreate(entityRecordforSave).toPromise();
            }

            cp.then((newrecord) => {
                this.entityRecord = newrecord;
                let label = newrecord.id;
                if (newrecord.data && newrecord.data[this.entity['record_name']]) {
                    label = newrecord.data[this.entity['record_name']];
                } else if (newrecord.data && newrecord.data.uniqueId) {
                    label = newrecord.data.uniqueId;
                } else if (newrecord.data && newrecord.data.name) {
                    label = newrecord.data.name;
                }
                this.notify('success', 'Created ' + this.entity.label, label);
                this.loadingModal.hide();
                if (this.entity.open_detail_page_on_create) {
                    this.router.navigate(['/detail/' + this.entity.id + '/' + this.entityRecord.id]);
                } else {
                    this.getRecords();
                }
            }).catch((err: any) => {
                this.loadingModal.hide();
                let errorMessage = 'Failed to create ' + this.entity.label;
                if (err && err.status === 400) {
                    if (err.error && err.error.message) {
                        errorMessage = err.error.message;
                    } else if (err.error && typeof err.error === 'string') {
                        errorMessage = err.error;
                    } else if (err.message) {
                        errorMessage = err.message;
                    }
                    this.notify('error', 'Validation Error', errorMessage);
                } else {
                    if (err && err.message) {
                        errorMessage = err.message;
                    } else if (err && err.error && err.error.message) {
                        errorMessage = err.error.message;
                    }
                    this.notify('error', 'Error', errorMessage);
                }
                console.error('Error in patchOrCreateEntity (create):', err);
            });
        } else {
            let cp;
            if (this.entity.collection && this.entity.collection != 'entityrecord') {
                cp = this._http.patch(`${BASE_URL}/${API_VERSION}/${this.getApiNameFromCollection(this.entity.collection)}/${entityrecordid}`, entityRecordforSave, {
                    headers: this.getHeaders()
                }).toPromise().then(v => v.json()).catch(error => {
                    console.log('Error while updating', error);
                    throw error; // Re-throw to be caught by the outer catch
                });
            } else {
                cp = this._EntityrecordApi.patchAttributes(entityrecordid, entityRecordforSave).toPromise();
            }
            cp.then((newrecord) => {
                this.entityRecord = newrecord;
                let label = newrecord.id;
                if (newrecord.data && newrecord.data[this.entity['record_name']]) {
                    label = newrecord.data[this.entity['record_name']];
                } else if (newrecord.data && newrecord.data.uniqueId) {
                    label = newrecord.data.uniqueId;
                } else if (newrecord.data && newrecord.data.name) {
                    label = newrecord.data.name;
                }
                this.notify('success', 'Updated ' + this.entity.label, label);
                this.loadingModal.hide();
                this.getRecords();
            }).catch((err: any) => {
                this.loadingModal.hide();
                let errorMessage = 'Failed to update ' + this.entity.label;
                if (err && err.status === 400) {
                    if (err.error && err.error.message) {
                        errorMessage = err.error.message;
                    } else if (err.error && typeof err.error === 'string') {
                        errorMessage = err.error;
                    } else if (err.message) {
                        errorMessage = err.message;
                    }
                    this.notify('error', 'Validation Error', errorMessage);
                } else {
                    if (err && err.message) {
                        errorMessage = err.message;
                    } else if (err && err.error && err.error.message) {
                        errorMessage = err.error.message;
                    }
                    this.notify('error', 'Error', errorMessage);
                }
                console.error('Error in patchOrCreateEntity (update):', err);
            });
        }
    }

    toggleFieldStatus() {
        let selected_rows = this.gridOptions.api.getSelectedRows();
        this.reasonModal.hide();
        this.alertrecord = {};
        this.alertformfields = _.cloneDeep(this.bk_activate_action_fields);
        if (!this.open_field_exists) {
            this.alertformfields[0].templateOptions.options.splice(1);
        }
        // this.alertform = this.fb.group({});
        this.reasonModal.show();
    }

    bulkPatch(value) {
        this.hideModals(this.reasonModal, this.alertform);
        let selected_rows = this.gridOptions.api.getSelectedRows();
        const body = {
            ids: selected_rows.map(_r => _r.id),
            action: {
                type: 'set',
                values: value
            }
        }
        let cp;
        if (this.entity.collection && this.entity.collection != 'entityrecord') {
            cp = this._http.patch(`${BASE_URL}/${API_VERSION}/${this.getApiNameFromCollection(this.entity.collection)}/bulkpatch`, body, {
                headers: this.getHeaders()
            }).toPromise().then(v => v.json()).catch(error => {
                console.log('Error while findByIdProcessed', error);
            });
        } else {
            cp = this._EntityrecordApi.bulkPatch(body).toPromise();
        }
        cp.then(r => {
            this.notify('success', 'Updated All Selected Records');
            this.getRecords();
        }).catch(err => {
            console.error(err);
            this.notify('error', 'Bulk update failed');
        });
    }

    /*
    This method is used to invoke the grid button actions
    */

    public methodFromParent(item) {

        if (!(item && item.buttonaction && item.data)) {
            return;
        }
        if (item.buttonaction === 'view') {
            this.router.navigate(['/detail/' + this.entity.id + '/' + item.data.id]);
        } else if (item.buttonaction === 'peek') {
            this.showPeekModal(item.data);
        } else if (item.buttonaction === 'edit') {
            this.showEditModal(item.data);
        } else if (item.buttonaction === 'action') {
            this.processCustomAction(item.data);
        } else if (item.buttonaction === 'delete') {
            this.confirmDelete(item.data);
        } else if (item.buttonaction === 'moveup') {
            this.moveUp(item.data);
        } else if (item.buttonaction === 'movedown') {
            this.moveDown(item.data);
        } else if (item.buttonaction === 'status') {
            this.checkStatus(item.data);
        } else if (item.buttonaction === 'refund') {
            this.refund(item.data);
        } else if (item.buttonaction === 'cancel') {
            this.cancelOrder(item.data);
        }
    }

    public constructPaymentHash(payment) {
        let params = [this._LoopBackAuth.getAccessTokenId(), payment.customer,
        payment.paymentgateway, payment.paymenttype, payment.amount,
        payment.checksum.join('_'), payment.createdplatform];
        return encrypt(params.join('|'));
    }


    public constructOrderHash(cartorder) {
        console.log(cartorder);
        let params = [this._LoopBackAuth.getAccessTokenId(), cartorder.foodcourt, cartorder.parentId, cartorder.checksum, cartorder.restaurantcustomer];
        let _items = [];
        for (let _it of cartorder.items) {
            _items.push(_it.restaurantmenuitem + '_' + _it.totalprice);
        }
        params.push(_items.join('-'))
        params.push(cartorder.totalprice);
        params.push(cartorder.createdplatform);
        return encrypt(params.join('|'));
    }

    checkStatus(record) {
        if (this.entityid == "591d33c135ccd801c1b44ec3") {
            this._http.post(`${NEWBASE_URL}/${API_VERSION}/gokhana/paymenttransaction/${record.id}/update`, {}, { headers: this.getHeaders() })
                .map((res: any) => (res.text() != "" ? res.json() : {}))
                .toPromise()
                .then(r => {
                    this.getRecords();
                    this.notify('success', "Fetched Latest Status", record.id);
                }).catch(err => {
                    console.error(err);
                    this.notify('error', "Failed to get Latest Status", record.id);
                })

        }
    }

    refund(record) {
        if (this.entityid == "591d33c135ccd801c1b44ec3") {
            this._http.post(`${BASE_URL}/${API_VERSION}/gokhana/paymenttransaction/${record.id}/refund`, {}, { headers: this.getHeaders() })
                .map((res: any) => (res.text() != "" ? res.json() : {}))
                .toPromise()
                .then(r => {
                    this.getRecords();
                    this.notify('success', "Refunded Latest Status", record.id);
                }).catch(err => {
                    console.error(err);
                    this.notify('error', "Failed to get Latest Status", record.id);
                })

        }
    }

    cancelOrder(record) {
        // console.log()
        if (this.entityid == "5825d66df009c4bc37fd7bae") {
            this.reasonModal.hide();
            this.order = record;
            this.alertrecord = {};
            this.alertformfields = _.cloneDeep(this.bk_cancel_reason_fields);
            // this.alertform = this.fb.group({});
            this.reasonModal.show();
        }
    }

    takeActionOnOrderUpdate() {
        console.log(this.alertrecord);
        if (this.alertrecord.hasOwnProperty("reason") && isNotBlank(this.alertrecord.reason)) {
            console.log(this.order);
            const reason = this.alertrecord.reason;
            this.updateOrderStatus(this.order['data']['orderid'], { action: 'cancel', cancelledreason: reason })
            this.hideModals(this.reasonModal, this.alertform);
        } else if (this.alertrecord.hasOwnProperty("field")) {
            let l = {};
            l[this.alertrecord.field] = Boolean(this.alertrecord[this.alertrecord.field]);
            this.bulkPatch(l)
        }
    }

    updateOrderStatus(orderid, body) {
        this._http.post(`${NEWBASE_URL}/${API_VERSION}/gokhana/foodorder/${orderid}`, body, { headers: this.getHeaders() })
            .map((res: any) => (res.text() != "" ? res.json() : {}))
            .toPromise()
            .then(r => {
                this.getRecords();
                this.notify('success', "Order Status Updated", orderid);
            }).catch(err => {
                console.error(err);
                this.notify('error', "Failed to update order Status", orderid);
            })
    }

    moveUp(record) {
        console.log('moveup');
        //console.log(record);
    }

    moveDown(record) {
        console.log('movedown');
        //console.log(record);
    }

    checkforDateColumn(column) {
        if (column.fieldtype === 'dateandtime' || column.fieldtype === 'date') {
            return true;
        } else {
            return false;
        }
    }

    resetForm(form?): void {
        if (form) {
            if (form['subscriptions']) { form['subscriptions'].forEach(s => { s.unsubscribe(); }); }
            form = this.fb.group({});
            form['subscriptions'] = [];
            form['formValidity'] = true;
            form['viewMode'] = false;
            return
        }
        if (this.form) {
            if (this.form['subscriptions']) { this.form['subscriptions'].forEach(s => { s.unsubscribe(); }); }
            this.form = this.fb.group({});
            this.form['subscriptions'] = [];
            this.form['formValidity'] = true;
            this.form['viewMode'] = false;
        }
    }

    public showNewModal(): void {
        this.loadingModal.hide();
        this.loadText = 'New';
        this.loadingModal.show();
        this.hideModals();
        this.entityRecord = {};
        if (this.parentId) {
            this.entityRecord['parentId'] = this.parentId;
        }
        this.entityrecordid = null;
        this.formfields = _.cloneDeep(this.entityFormFields);
        this.initialFormData = _.cloneDeep(this.entityRecord);
        this.populateformfields();
        this.form['appData'] = this.appData;
        this.form['viewMode'] = false;
        this.form['formValidity'] = true;
        this.newModal.show();
        this.loadingModal.hide();
    }

    public hideModals(model?, form?): void {
        if (model) {
            console.log(model);
            model['hide']();
            this.resetForm(form);
            return;
        }
        this.newModal.hide();
        this.peekModal.hide();
        this.resetForm();
    }

    populateformfields() {
        this.formfields.forEach(ff => {
            this.populateFormGroup(ff);
        });
    }

    populateFormGroup(formgroup) {
        if (formgroup.type === 'repeatedsection') {
            formgroup.templateOptions['parentmodel'] = this.entityRecord;
        } else if (!formgroup.type && Array.isArray(formgroup.fieldGroup) && formgroup.fieldGroup.length > 0) {
            formgroup.fieldGroup.forEach(fg => {
                this.populateFormGroup(fg);
            });
        } else if (!formgroup.type && formgroup.fieldArray
            && Array.isArray(formgroup.fieldArray.fieldGroup)
            && formgroup.fieldArray.fieldGroup.length > 0) {
            formgroup.fieldArray.fieldGroup.forEach(fg => {
                this.populateFormGroup(fg);
            });
        }
    }

    public showEditModal(selectedEntityRecord): void {
        this.loadingModal.hide();
        this.loadText = 'Edit';
        this.loadingModal.show();
        this.hideModals();
        let cp;
        if (this.entity.collection && this.entity.collection != 'entityrecord') {
            cp = this._http.get(`${BASE_URL}/${API_VERSION}/${this.getApiNameFromCollection(this.entity.collection)}/edit/${selectedEntityRecord.id}`, {
                headers: this.getHeaders()
            }).toPromise().then(v => v.json()).catch(error => {
                console.log('Error while findByIdforEdit', error);
            });
        } else {
            cp = this._EntityrecordApi.findByIdforEdit(selectedEntityRecord.id).toPromise();
        }
        cp.then((record) => {
            if (record && record['response']) {
                if (record['response']['record'] && record['response']['record']['data']) {
                    this.entityRecord = _.cloneDeep(record['response']['record']['data']);
                } else {
                    this.entityRecord = {};
                }
                if (record['response']['formfields']) {
                    this.entityFormFields = record['response']['formfields'];
                }
                this.formfields = _.cloneDeep(this.entityFormFields);

                this.entityrecordid = selectedEntityRecord.id;
                this.entityRecord.id = selectedEntityRecord.id;
                this.initialFormData = _.cloneDeep(this.entityRecord);
                this.populateformfields();
                this.form['appData'] = this.appData;
                this.form['viewMode'] = false;
                this.form['formValidity'] = true;
                this.newModal.show();
                this.loadingModal.hide();
            } else {
                console.error('ERROR - Loading Record ' + selectedEntityRecord.id);
                this.notify('error', 'Record', 'Not Loaded; Please refresh');
            }
        });
    }

    public showPeekModal(selectedEntityRecord): void {
        this.loadingModal.hide();
        this.loadText = 'View';
        this.loadingModal.show();
        this.hideModals();
        let cp;
        if (this.entity.collection && this.entity.collection != 'entityrecord') {
            cp = this._http.get(`${BASE_URL}/${API_VERSION}/${this.getApiNameFromCollection(this.entity.collection)}/full/${selectedEntityRecord.id}`, {
                headers: this.getHeaders()
            }).toPromise().then(v => v.json()).catch(error => {
                console.log('Error while findByIdProcessed', error);
            });
        } else {
            cp = this._EntityrecordApi.findByIdProcessed(selectedEntityRecord.id).toPromise();
        }
        cp.then((record) => {
            if (record && record['response'] && record['response']['data']) {
                this.entityRecord = record['response']['data'];
                this.entityrecordid = selectedEntityRecord.id;
                this.entityRecord.id = selectedEntityRecord.id;
                this.formfields = this.makeLabels(_.cloneDeep(this.entityFormFields));
                this.initialFormData = _.cloneDeep(this.entityRecord);
                this.form['appData'] = this.appData;
                this.form['viewMode'] = true;
                this.form['formValidity'] = true;
                this.peekModal.show();
                this.loadingModal.hide();
            }
        });
    }

    makeLabels(formfields) {
        for (let index = 0; index < formfields.length; index++) {
            if (formfields[index].fieldGroup && formfields[index].fieldGroup.length > 0) {
                this.makeLabels(formfields[index].fieldGroup);
            } else if (formfields[index].fieldArray && formfields[index].fieldArray.length > 0) {
                this.makeLabels(formfields[index].fieldArray);
            } else if (formfields[index].fieldArray
                && formfields[index].fieldArray.fieldGroup
                && formfields[index].fieldArray.fieldGroup.length > 0) {
                if (formfields[index].type === 'repeatedsection' || formfields[index].type === 'subentity') {
                    formfields[index].className = 'col-md-12';
                }
                this.makeLabels(formfields[index].fieldArray.fieldGroup);
            } else if (formfields[index].type && formfields[index].templateOptions) {
                console.log(formfields[index]);
                if (formfields[index].key == 'password') formfields[index].hideExpression = 'true';
                formfields[index].type = 'input-field';
                formfields[index].templateOptions.readonly = true;
            }
        }
        return formfields;
    }

    public exporttoExcel() {
        let records = [];
        let columns = this.columnstoExport();
        let row = [];
        columns.forEach(c => {
            row.push({ value: c.getColDef().headerName, type: c.getColDef()['fieldtype'] });
        });
        records.push(row);
        this.gridOptions.api.forEachNode(rowd => {
            row = [];
            columns.forEach(c => {
                let col = { value: this._getValue(rowd.data, c.getColId()), type: c.getColDef()['fieldtype'] };
                row.push(col);
            });
            records.push(row);
        });
        let config = {
            filename: this.getExportFileName(),
            sheet: { data: records }
        };
        zipcelx(config);
    }

    exporttoCSV() {
        let params = {
            skipHeader: false,
            columnGroups: true,
            skipFooters: true,
            skipGroups: false,
            skipFloatingTop: true,
            skipFloatingBottom: true,
            suppressQuotes: false,
            columnKeys: this.columnstoExport(),
            fileName: this.getExportFileName(),
            columnSeparator: ';',
            processCellCallback: function (parameters) {
                if ((parameters.column.colDef.fieldtype === 'dateandtime'
                    || parameters.column.colDef.fieldtype === 'date'
                    || parameters.column.colDef.fieldtype === 'time'
                    || parameters.column.colDef.fieldtype === 'currency')
                    && parameters.value) {
                    return parameters.value.display;
                } else {
                    return parameters.value;
                }

            }
        };
        this.gridOptions.api.exportDataAsCsv(params);
    }

    _getValue(obj, fieldName) {
        let names = fieldName.split('.');
        let o = obj;
        names.forEach(n => {
            if (o) {
                o = o[n];
            }
        });
        //console.log(fieldName, o);
        return o;
    }

    columnstoExport() {
        //console.log(this.gridOptions.columnApi.getAllDisplayedColumns());
        return this.gridOptions.columnApi.getAllDisplayedColumns();
    }

    getExportFileName() {
        return this.entity.plural_label;
    }

    public updateValidations(formfields) {
        for (let i = 0; i < formfields.length; i++) {
            let formField = formfields[i];
            let fieldType = formField.type;
            let fieldSubType = '';
            let validators = [];

            if (formField.templateOptions.type) {
                fieldSubType = formField.templateOptions.type;
            } else {
                fieldSubType = 'text';
            }

            switch (fieldType) {
                case 'input-field':
                    switch (fieldSubType) {
                        case 'email':
                            validators.push(ValidationService.emailValidator);
                            break;
                        case 'phone':
                            validators.push(ValidationService.phoneValidator);
                            break;
                        case 'default':
                            break;
                    }
                    break;
                case 'geolocation':
                    validators.push(ValidationService.geolocationValidator);
                    break;
                case 'default':
                    break;
            }
            formField['validators'] = { validation: Validators.compose(validators) };

            if (this.parentId && formField.key === 'parentId') {
                formField.templateOptions.disabled = true;
            }
        }
        return formfields;
    }

    public toggled(open: boolean): void { }

    notify(type, title?, content?, options?) {
        if (!options) { options = PlatformApp.getNotificationOptions(); }
        if (!options.id) { options.id = type + '-' + title + '_' + content; }
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }

    getGridHeight() {
        if (this.winRef.nativeWindow && this.winRef.nativeWindow.innerHeight && this.inversegridheight) {
            return (this.winRef.nativeWindow.innerHeight - this.inversegridheight) + 'px';
        } else {
            return '500px';
        }
    }

    onResize() {
        if (this.gridheight) {
            this.calcgridheight = this.gridheight;
        } else if (this.inversegridheight) {
            this.calcgridheight = this.getGridHeight();
        }
    }

    getApiNameFromCollection(coll) {
        if (coll == 'gokashplus' || coll == 'gokashcredit') return coll;
        else return coll + 's';
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/grid-list/grid-list.component.ts